jQuery(document).ready(function ($) {
  feather.replace();
});